import React from 'react'
import styled from '@emotion/styled'
import { SvgIconStyled } from '@mobi/component-library/Common/Icon/Icon.styles'

export const Night = () => {
  return (
    <SvgIconStyled
      width='40'
      height='40'
      viewBox='0 0 64 64'
      fill='none'
      size='3rem'
      data-testid='night'
    >
      <defs>
        <filter id='blur' width='200%' height='200%'>
          <feGaussianBlur in='SourceAlpha' stdDeviation='3' />
          <feOffset dx='0' dy='4' result='offsetblur' />
          <feComponentTransfer>
            <feFuncA type='linear' slope='0.05' />
          </feComponentTransfer>
          <feMerge>
            <feMergeNode />
            <feMergeNode in='SourceGraphic' />
          </feMerge>
        </filter>
      </defs>
      <g filter='url(#blur)' id='night'>
        <g transform='translate(20,20)'>
          <Star style={{ animationDelay: '3s', animationDuration: '5s' }}>
            <polygon
              fill='orange'
              points='3.3,1.5 4,2.7 5.2,3.3 4,4 3.3,5.2 2.7,4 1.5,3.3 2.7,2.7'
              stroke='none'
              strokeMiterlimit='10'
            />
          </Star>
          <Star style={{ animationDelay: '5s', animationDuration: '4s' }}>
            <polygon
              fill='orange'
              points='3.3,1.5 4,2.7 5.2,3.3 4,4 3.3,5.2 2.7,4 1.5,3.3 2.7,2.7'
              stroke='none'
              strokeMiterlimit='10'
              transform='translate(20,10)'
            />
          </Star>
          <Moon>
            <path
              d='M14.5,13.2c0-3.7,2-6.9,5-8.7   c-1.5-0.9-3.2-1.3-5-1.3c-5.5,0-10,4.5-10,10s4.5,10,10,10c1.8,0,3.5-0.5,5-1.3C16.5,20.2,14.5,16.9,14.5,13.2z'
              fill='orange'
              stroke='orange'
              strokeLinejoin='round'
              strokeWidth='2'
            />
          </Moon>
        </g>
      </g>
    </SvgIconStyled>
  )
}

// ======
// Styles
// ======

const Star = styled.g({
  animationName: 'starAnimation',
  animationTimingFunction: 'linear',
  animationIterationCount: 'infinite',
  animationDirection: 'alternate',

  ['@keyframes starAnimation']: {
    '0%': { opacity: 0.05 },
    '100%': { opacity: 1 },
  },
})

const Moon = styled.g({
  animationName: 'moonAnimation',
  animationDuration: '6s',
  animationTimingFunction: 'linear',
  animationIterationCount: 'infinite',
  transformOrigin: '12.5px 15.15px 0',

  ['@keyframes moonAnimation']: {
    '0%': { transform: 'rotate(0deg)' },
    '50%': { transform: 'rotate(15deg)' },
    '100%': { transform: 'rotate(0deg)' },
  },
})
